import React, { Component } from 'react'
import Header from '../components/Header'
import Card1 from '../components/cards/Card1'
import { connect } from 'react-redux';
import { changeStateValue } from '../redux/MainReducer';
import { getAboutData} from '../actions/MainAction';
export class MainPage extends Component {
  
  openModal=(data, lang, lang_id=1)=>{
    this.props.changeStateValue({
      name:"mainModal",
      value:{
        position:true,
        id: data?.id?data?.id:"",
        image: data?.image?data?.image:"",
        image_full_url: data?.image_full_url?data?.image_full_url:"",
        languages:
          {
            id:lang?.id?lang?.id:'',
            title:lang?.title?lang?.title:'',
            description:lang?.description?lang?.description:'',
            lang_id:lang_id
          }
        ,
        requiredsLang: ["title"],
        requireds:[],
        afterCallFunction:this.props.getAboutData,
        afterParams:[],
        url:'admin-about'
      }
    })
  }

  componentDidMount(){
    this.props.getAboutData();
  }
  render() {
    const {adminAbouts} = this.props;
    console.log(adminAbouts)
    return (
      <div className='p-[40px] w-full'>
        <Header onClickBtn={this.openModal.bind(this, "", "", 1)} title="About Data" />
        <div className='grid-full-250 grid grid-cols-2 mt-[20px]'>
          {
            adminAbouts?.map((data, i)=>{
              return(
                <Card1 
                  key={i}
                  image={data?.image_full_url}
                  video={data?.video_full_url}
                  onChangeLang={(id)=>this.openModal(data, data.translates.find(x=>x.lang_id==id), id)} 
                  title1={data?.translate?.title}
                  deleteUrl={`admin-about/${data?.id}`}
                  afterCallFunction={()=> this.props.getAboutData()}
                />
              )
            })
          }
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state)=>({
  adminAbouts: state.Data.adminAbouts,
});
const mapDispatchToProps = {changeStateValue, getAboutData}
export default connect(mapStateToProps, mapDispatchToProps)(MainPage)
